import { Injectable } from '@angular/core';
import {
  Action,
  AngularFirestore,
  AngularFirestoreCollection,
  DocumentChangeAction,
  DocumentReference,
  DocumentSnapshot,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { QuinielaJugada } from '../models/quiniela-jugada';

@Injectable({
  providedIn: 'root',
})
export class QuinielaJugadaService {
  private quinielajugadaCollection: AngularFirestoreCollection<QuinielaJugada>;

  constructor(private db: AngularFirestore) {
    this.quinielajugadaCollection = this.db.collection<QuinielaJugada>('quinielajugadas');
  }

  /**
   * GET ALL Quiniela JugadaS
   */
  getAllQuinielaJugadas(): Observable<DocumentChangeAction<QuinielaJugada>[]> {
    return this.quinielajugadaCollection.snapshotChanges();
  }

  /**
   * GET Quiniela Jugada BY ID
   * @param quinielajugadaId
   */
  getQuinielaJugada(quinielajugadaId: string): Observable<Action<DocumentSnapshot<QuinielaJugada>>> {
    return this.quinielajugadaCollection.doc<QuinielaJugada>(quinielajugadaId).snapshotChanges();
  }

  /**
   * CREATE NEW Quiniela Jugada
   * @param newQuinielaJugada
   */
  createQuinielaJugada(newQuinielaJugada: QuinielaJugada): Promise<DocumentReference> {
    return this.quinielajugadaCollection.add(newQuinielaJugada);
  }

  /**
   * UPDATE SELECTED Quiniela Jugada
   * @param data
   * @param docId
   */
  updateQuinielaJugada(data: QuinielaJugada, docId: string): Promise<void> {
    return this.quinielajugadaCollection.doc<QuinielaJugada>(docId).update(data);
  }

  /**
   * DELETE Quiniela Jugada
   * @param docId
   */
  deleteQuinielaJugada(docId: string): Promise<void> {
    return this.quinielajugadaCollection.doc<QuinielaJugada>(docId).delete();
  }

  /**
   * GET ALL PARTIDOS por id usa el parametro idQuiniela
   */
  public getAllPartidosByIdJugador(idJugador: any): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('quinielajugadas', (ref) =>
      ref.where('id_jugador', '==', idJugador)
    );
    return query.snapshotChanges()
    //return this.partidoCollection.snapshotChanges();
  }

  /**
   * GET ALL PARTIDOS JUGADOS DE UNA QUINIELA
   */
  public getAllPartidosJugadosByIdPartido(idPartido: string): Observable<DocumentChangeAction<any>[]> {
    var query = this.db.collection('quinielajugadas', (ref) =>
      ref.where('id_partido', '==', idPartido)
    );
    return query.snapshotChanges()
  }

  /**
* DELETE ALL QUINIELAS JUGADAS DE UNA QUINIELA POR SU ID
*/
  deleteAllQuinielasJugadasByIdQuiniela(id_quiniela: any): void {
    let query = this.db.collection('quinielajugadas', ref => ref.where('id_quiniela', '==', id_quiniela));
    query.get().toPromise().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        doc.ref.delete();
      });
    });
  }
}
